import { ITERSamplesAndTests } from "../../models/TERSamplesAndTests";
import { ITERApplicationDetails } from "../../models/TERApplicationDetails";
import { IChooseApp } from "../../models/ChooseApp";
import { IPersonalInfo } from "../../models/PersonalInfo";
import { IFilerInformation } from "../../models/FilerInformation";
import { IlabTERPreference } from "../../models/TERPreference";
export interface ITERRequest {
  labTERPersonalInfoDetails: IPersonalInfo;
  labTERChooseApplDetails: IChooseApp;
  labTERFilerInfoDetails: IFilerInformation;
  labTERApplicationDetails: ITERApplicationDetails;
  labTERSampleTests: ITERSamplesAndTests[];
  labApplicationchangedDetails?: ITERApplicationDetails;
  labChangedPreference?: IlabTERPreference;
  labchangedSampleTestDetails?: ITERSamplesAndTests[];
  labTERPreference: IlabTERPreference;
  applicationNumber?: string;
  actionStatus?: string;
  submittedFeedback?: number;
  isReportGenerated?: number;
  reasonForCancellation?: string;
  labReportDetails?: string;
  labTERApplicationStatus?: ITERApplicationStatus;
}

export interface ITERApplicationStatus {
  applicationRequestFor: number;
  miiApplication: number;
  eserviceApplication: number;
  islabapplicationamended?: number;
  islabapplicationcancelled?: number;
  islabapplicationDuplicated?: number;
  actionedStatus?: string;
  amendmentRaisedStage?: number | null;
  ActionRequest: string;
}

export const defTERAmmendAppStatus: ITERApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 18,
  eserviceApplication: 14,
  islabapplicationamended: 1,
  ActionRequest: "Amendment request",
};
export const defTERAmmendRowAppStatus: ITERApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 30,
  eserviceApplication: 20,
  islabapplicationamended: 1,
  ActionRequest: "Amendment request",
};

export const defTERCancelAppStatus: ITERApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 25,
  eserviceApplication: 17,
  islabapplicationcancelled: 1,
  ActionRequest: "Cancel request",
};
export const defTERAppStatus: ITERApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 2,
  eserviceApplication: 2,
  ActionRequest: "Application Submitted",
};

export const defTERExchangeAppStatus: ITERApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 2,
  eserviceApplication: 2,
  ActionRequest: "Application Submitted",
};
export const defDuplicateAppStatus: ITERApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 31,
  eserviceApplication: 21,
  islabapplicationDuplicated: 1,
  ActionRequest: "Duplicate request",
};
